import { CreateUnitQueryArg } from '../types/query-arg';
import { CreateUnitQueryBody } from '../types/query-body';

export const createUnitQueryBody = ({
  organisation,
  unitName,
  groupId,
}: CreateUnitQueryArg): CreateUnitQueryBody => ({
  organisationId: organisation.id,
  unitName,
  groupId,
});
